import { Link } from "react-router-dom";
import instructorImage from "../assets/instructor.jpg";
import carImage from "../assets/car.jpg";
import locationImage from "../assets/location.jpg";

const Introduction = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 p-6 md:p-10">
      <div className="max-w-5xl mx-auto space-y-12">

        {/* Giới thiệu giáo viên */}
        <section className="bg-red-100 p-6 rounded-lg flex flex-col items-center text-center md:flex-row md:text-left md:items-center gap-6">
          <img
            src={instructorImage}
            alt="Giáo viên dạy lái"
            className="w-48 h-48 rounded-full object-cover border-4 border-red-500"
          />
          <div className="text-2xl">
            <h1 className="text-3xl font-bold mb-2">🧑‍🏫 Giới thiệu giáo viên</h1>
            <p><strong>Họ tên:</strong> Nguyễn Lê Thanh Quốc</p>
            <p><strong>Chứng chỉ:</strong> GPLX hạng DCE</p>
            <p><strong>Kinh nghiệm:</strong> Hơn 10 năm dạy lái xe</p>
            <p><strong>Tỷ lệ học viên đậu:</strong> 95% đậu ngay lần đầu</p>
          </div>
        </section>

        {/* Thành tích và Lịch dạy */}
        <section className="flex flex-col md:flex-row gap-6">
          {/* Thành tích */}
          <div className="flex-1 bg-yellow-100 p-6 rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-4">⭐ Thành tích nổi bật</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Đào tạo hơn <strong>500+</strong> học viên thành công</li>
              <li>Được đánh giá 5★ bởi hơn 200 học viên</li>
              <li>Hợp tác với nhiều trung tâm sát hạch lớn</li>
            </ul>
          </div>

          {/* Lịch dạy */}
          <div className="flex-1 bg-green-100 p-6 rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-4">📅 Lịch dạy linh hoạt & hỗ trợ</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Lịch học linh hoạt theo giờ học viên: Sáng - Chiều - Tối - Cuối tuần</li>
              <li>Hỗ trợ đưa đón tại các khu vực trong thành phố khu vực Dĩ An - HCM</li>
              <li>Chăm sóc, theo sát tiến độ từng học viên</li>
            </ul>
          </div>
        </section>

        {/* Phương tiện */}
        <section className="bg-blue-100 p-6 rounded-lg flex flex-col md:flex-row items-center gap-6 shadow-md">
          <img
            src={carImage}
            alt="Xe tập lái"
            className="w-full md:w-1/2 h-60 object-cover rounded-lg shadow"
          />
          <div>
            <h2 className="text-2xl font-bold mb-4">🚗 Phương tiện & cơ sở vật chất</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Xe số sàn và số tự động đời mới</li>
              <li>Sân tập đạt chuẩn, rộng rãi, sạch sẽ</li>
              <li>Bảo dưỡng xe định kỳ đảm bảo an toàn</li>
              <li><strong>Địa điểm học:</strong> Gần Làng Đại Học, Thủ Đức - thuận tiện cho sinh viên & người đi làm.</li>
            </ul>
          </div>
        </section>

        {/* Liên hệ */}
        <section className="bg-purple-100 p-6 rounded-lg shadow-md flex flex-col md:flex-row items-center gap-6">
          <img
            src={locationImage}
            alt="Địa điểm học lái"
            className="w-full md:w-1/3 h-40 object-cover rounded-md"
          />
          <div className="space-y-2">
            <h2 className="text-2xl font-bold mb-2">📞 Liên hệ & Đăng ký</h2>
            <p><strong>📍 Địa điểm:</strong> 60/12B Đ Lồ Ô, Phường Đông Hòa, Thành phố Hồ Chí Minh, Việt Nam</p>
            <p><strong>📱 Số điện thoại / Zalo:</strong> 0786529313</p>
            <p>
              <strong>🌐 Facebook:</strong>{" "}
              <a
                href="https://www.facebook.com/daylaixe.quoc"
                className="text-red-600 underline"
              >
                fb.com/daylaixe.quoc
              </a>
            </p>
            <Link to="/lien-he">
              <button className="mt-4 px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition">
                Đăng ký ngay
              </button>
            </Link>
          </div>
        </section>

      </div>
    </div>
  );
};

export default Introduction;